import React from 'react';
import { Header } from '../../components/Header';
import { Footer } from '../../components/Footer';
import { HeroSection } from './HeroSection';
import { AboutSection } from './AboutSection';
import { MembershipSection } from './MembershipSection';
import { MemberLoginSection } from './MemberLoginSection';
import { EventsSection } from './EventsSection';
import { ActivitiesSection } from './ActivitiesSection';
import { SportingClaysSection } from './SportingClaysSection';
import { EducationSection } from './EducationSection';
import { PPCSection } from './PPCSection';
import { FacilitiesSection } from './FacilitiesSection';
import { LeaguesSection } from './LeaguesSection';
import { QuickFactsSection } from './QuickFactsSection';
import { TrainingSection } from './TrainingSection';
import { NewsletterSection } from './NewsletterSection';
import { LocationSection } from './LocationSection';
import { AffiliationsSection } from './AffiliationsSection';
export function HomePage() {
  return <main className="w-full" data-id="element-1791">
      <Header data-id="element-1792" />
      <HeroSection data-id="element-1793" />
      <AboutSection data-id="element-1794" />
      <section id="member-login" className="w-full py-14 md:py-18" style={{
      backgroundColor: '#1e3d2f'
    }} aria-label="Membership" data-id="element-1795">
        <div className="max-w-6xl mx-auto px-4 md:px-8" data-id="element-1796">
          <div className="flex flex-col lg:flex-row gap-8 lg:gap-12 items-stretch" data-id="element-1797">
            <MembershipSection data-id="element-1798" />
            <MemberLoginSection data-id="element-1799" />
          </div>
        </div>
      </section>
      <EventsSection data-id="element-1800" />
      <ActivitiesSection data-id="element-1801" />
      <SportingClaysSection data-id="element-1802" />
      <EducationSection data-id="element-1803" />
      <PPCSection data-id="element-1804" />
      <FacilitiesSection data-id="element-1805" />
      <LeaguesSection data-id="element-1806" />
      <QuickFactsSection data-id="element-1807" />
      <TrainingSection data-id="element-1808" />
      <NewsletterSection data-id="element-1809" />
      <LocationSection data-id="element-1810" />
      <AffiliationsSection data-id="element-1811" />
      <Footer data-id="element-1812" />
    </main>;
}